import * as types from '@/store/mutation-types';
import { getColClass } from './utils';

const mutations = {
  [types.ADD_COLUMN](state, p) {
    const drp = p.drp;
    drp.columns.push(p.newCol);
    const dynColClass = getColClass(drp.columns.length);
    drp.columns = drp.columns.map(c => Object.assign(
      {},
      c,
      { dynColClass }),
    );
  },
  [types.REMOVE_COLUMN](state, p) {
    const drp = p.drp;
    drp.columns.splice(p.colIndex, 1);
    const dynColClass = getColClass(drp.columns.length);
    drp.columns = drp.columns.map(c => Object.assign(
      {},
      c,
      { dynColClass }),
    );
  },
  [types.SET_COLUMN_WIDTH](state, p) {
    const drp = p.drp;
    drp.columns[p.colIndex].mediaQueries[0].desktop = p.width;
    if (p.nextColWidth) {
      drp.columns[p.nextColIndex].mediaQueries[0].desktop = p.nextColWidth;
    }
  },
  [types.SET_COLUMN_HEIGHTS](state, p) {
    const drp = p.drp;
    drp.equalHeights = p.equalHeights;
  },
};

const actions = {
  addNewColumn: ({ commit }, payload) => {
    commit(types.ADD_COLUMN, payload);
  },
  removeColumn: ({ commit }, payload) => {
    commit(types.REMOVE_COLUMN, payload);
  },
  setColumnWidth: ({ commit }, payload) => {
    commit(types.SET_COLUMN_WIDTH, payload);
  },
  setColumnHeights: ({ commit }, payload) => {
    commit(types.SET_COLUMN_HEIGHTS, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/columns/vuex.js